import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { OMEGA3_MEDIA } from '../data/omega3Data';
import { Icon } from '../../elements/icon';

const Omega3MediaCarousel = ({ className = '' }) => {
  const { t, i18n } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const isGerman = i18n.language?.startsWith('de');

  return (
    <div className={className}>
      <div className="t-relative t-overflow-hidden t-rounded-lg t-bg-surface">
        <Carousel
          selectedItem={activeIndex}
          onChange={(index) => setActiveIndex(index)}
          showArrows
          showIndicators={false}
          showThumbs={false}
          showStatus={false}
          swipeable={false}
          preventMovementUntilSwipeScrollTolerance
          swipeScrollTolerance={100}
          renderArrowPrev={(onClickHandler, hasPrev) => (
            <Icon
              name="chevronLeft"
              onClick={hasPrev ? onClickHandler : undefined}
              className={`t-absolute -t-left-1 t-top-[45%] t-rounded-[0_8px_8px_0] t-p-1 t-w-8 t-h-8 t-z-10 ${
                hasPrev
                  ? 't-bg-white t-text-navy t-shadow-md hover:t-bg-g100'
                  : 't-bg-g200 t-text-g300 t-cursor-not-allowed t-opacity-50'
              }`}
            />
          )}
          renderArrowNext={(onClickHandler, hasNext) => (
            <Icon
              name="chevronRight"
              onClick={hasNext ? onClickHandler : undefined}
              className={`t-absolute -t-right-1 t-top-[45%] t-rounded-[8px_0_0_8px] t-p-1 t-w-8 t-h-8 t-z-10 ${
                hasNext
                  ? 't-bg-white t-text-navy t-shadow-md hover:t-bg-g100'
                  : 't-bg-g200 t-text-g300 t-cursor-not-allowed t-opacity-50'
              }`}
            />
          )}
        >
          {OMEGA3_MEDIA.map((item) => (
            <div key={item.id} className="t-aspect-square">
              <img
                src={isGerman ? item.de : item.en}
                alt={t(item.altKey)}
                className="t-h-full t-w-full t-object-cover"
              />
            </div>
          ))}
        </Carousel>
        <div className="t-pointer-events-none t-absolute t-bottom-5 t-left-5 t-rounded-full t-bg-navy t-px-3.5 t-py-2 t-text-[12px] t-font-bold t-tracking-[0.04em] t-text-white">
          {t('Omega3_Hero_ImageBadge')}
        </div>
      </div>

      <div className="t-mt-3 t-flex t-gap-2">
        {OMEGA3_MEDIA.map((item, index) => (
          <button
            key={item.id}
            type="button"
            className={`t-h-16 t-w-16 t-overflow-hidden t-rounded-lg t-border-2 t-bg-surface t-p-0 ${
              index === activeIndex ? 't-border-quiz-teal' : 't-border-g200 t-opacity-60'
            }`}
            onClick={() => setActiveIndex(index)}
            aria-label={t(item.altKey)}
          >
            <img
              src={isGerman ? item.de : item.en}
              alt={t(item.altKey)}
              className="t-h-full t-w-full t-object-cover"
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default Omega3MediaCarousel;
